var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLineTitles(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 247.613,
    height: 4,
    viewBox: "0 0 247.613 4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b,.c{fill:#0cf;}.a{opacity:0.6;}.b{opacity:0.3;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-836 -1057)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(99.669 653.268)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M761.267,407.732h19.61l-1.466-2H759.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M737.8,407.732h15.61l-1.466-2h-15.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M788.584,407.732H931.69l1.466-2H787.118Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M939.4,407.732h19.61l1.466-2h-19.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M966.868,407.732h15.61l1.466-2h-15.61Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(101.021 676.952)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M770.808,383h28.962l-2.165-2.954H768.643Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M741.145,383H764.2l-2.165-2.954H738.979Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M947.773,383H918.811l2.165-2.954h28.962Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M977.437,383H954.382l2.165-2.954H979.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M808.612,383H909.969l2.165-2.954H806.447Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineTitles);
export default __webpack_public_path__ + "static/media/line_titles.c0d2fd933f3cf83f3d2865024a6375da.svg";
export { ForwardRef as ReactComponent };